// Generated by DesignToCode

import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

export type Status = 'active' | 'default' | 'hover';

@Component({
  selector: 'app-menu-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './menu-item.html',
})
export class MenuItem {
  // Inputs
  public label = input<string>('Engineering');
  public status = input<Status>('default');

  public containerClasses = computed(() => {
    const classes: string[] = [
      'flex',
      'flex-col',
      'flex-nowrap',
      'items-start',
      'justify-start',
      'h-fit',
      'w-fit',
      'pb-1',
      'group',
      'cursor-pointer',
    ];

    if (this.status() === 'active') {
      classes.push('border-b-2', 'border-black');
    }

    return classes.join(' ');
  });

  public labelClasses = computed(() => {
    const classes: string[] = [
      'flex',
      'flex-row',
      'flex-wrap',
      'items-start',
      'justify-start',
      'h-fit',
      'w-fit',
      'text-base',
      'font-semibold',
      'tracking-normal',
      'leading-5',
      'text-left',
    ];

    if (this.status() === 'default') {
      classes.push('text-slate-500', 'group-hover:text-black');
    } else if (this.status() === 'hover') {
      classes.push('text-black');
    } else if (this.status() === 'active') {
      classes.push('text-black');
    }

    return classes.join(' ');
  });
}
